import { logout } from "./store-actions";
import { baseHttp } from "./http";
import store from "configs/store";

baseHttp.interceptors.request.use((config:any) => {
  const { jwt } = store.getState().global.authUser || {};

  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`;
  }

  return config;
});

baseHttp.interceptors.response.use(undefined, (error:any) => {
  const authUser = store.getState().global.authUser;

  if (error?.response?.status === 401 && authUser) {
    store.dispatch(logout());
  }
  return Promise.reject(error);
});
